import React from 'react';
import ReactMarkdown from 'react-markdown';
import MuvingAnimation from './MuvingAnimation';
// Per icone più sofisticate, potresti importare da una libreria come react-icons
// import { FiLink } from 'react-icons/fi';

function Message({ message }) {
  if (!message) return null;

  const messageClass = message.sender === 'user' ? 'user-message' : 'ai-message';
  const alignmentClass = message.sender === 'user' ? 'message-right' : 'message-left';
  const errorClass = message.isError ? 'error-message' : '';

  if (message.isLoading && message.sender === 'ai' && !message.text) {
    return (
      <div className={`message-row ${alignmentClass} ai-loading-placeholder-row`}>
        <MuvingAnimation />
      </div>
    );
  }

  // Definisci un renderer custom per i link (tag <a>)
  const customRenderers = {
    a: ({ node, ...props }) => (
      <a
        href={props.href}
        target="_blank" // Apre il link in una nuova tab
        rel="noopener noreferrer" // Per sicurezza
        className="markdown-processed-link" // Classe per lo styling specifico
      >
        {props.children} {/* Testo del link */}
        <span className="link-icon" aria-hidden="true">
          {' '} {/* Spazio prima dell'icona */}
          🔗 {/* Icona Unicode per il link (puoi sostituirla con un SVG o icona da libreria) */}
          {/* Esempio con react-icons: <FiLink style={{ marginLeft: '3px', verticalAlign: 'middle' }} /> */}
        </span>
      </a>
    ),
  };

  return (
    <div className={`message-row ${alignmentClass}`}>
      <div className={`message-bubble ${messageClass} ${errorClass}`}>
        <div className="markdown-content-wrapper">
          <ReactMarkdown components={customRenderers}>
            {message.text || ''}
          </ReactMarkdown>
        </div>

        {/* Animated Typing Indicator */}
        {message.isLoading && message.sender === 'ai' && message.text && (
          <div className="typing-indicator-inline">
            <span></span> {/* Dot 1 */}
            <span></span> {/* Dot 2 */}
            <span></span> {/* Dot 3 */}
          </div>
        )}
      </div>
    </div>
  );
}

export default Message;